export default __webpack_public_path__ + "static/media/BG.979e585b.jpg";